const STORAGE_PREFIX = "Trends";
const STORAGE_VERSION = 1;

export const trendSelectionsStorageKey = (systemId) => `${STORAGE_PREFIX}_${systemId}`;

const CHARTS = ["chart1", "chart2", "chart3", "chart4"];

// Runtime-only flags are dropped so a restored selection never comes back as loading/errored.
const stripRuntimeFields = (item) => {
  const { loading, fetchErrorMsg, fetchErrorStatus, requiresDataLoading, ...persisted } = item;
  return persisted;
};

const isEmptySelection = (devicesFilterList) =>
  !devicesFilterList ||
  Object.values(devicesFilterList).every(
    (chart) => !chart || Object.keys(chart).length === 0
  );

export const saveTrendSelections = (systemId, devicesFilterList) => {
  if (!systemId) return;
  try {
    if (isEmptySelection(devicesFilterList)) {
      localStorage.removeItem(trendSelectionsStorageKey(systemId));
      return;
    }
    const toStore = {};
    CHARTS.forEach((chart) => {
      const devices = devicesFilterList[chart];
      if (!devices) return;
      toStore[chart] = {};
      Object.keys(devices).forEach((hwId) => {
        toStore[chart][hwId] = {};
        Object.keys(devices[hwId]).forEach((valueName) => {
          toStore[chart][hwId][valueName] = stripRuntimeFields(devices[hwId][valueName]);
        });
      });
    });
    localStorage.setItem(
      trendSelectionsStorageKey(systemId),
      JSON.stringify({ v: STORAGE_VERSION, charts: toStore })
    );
  } catch (error) {
    console.warn("Failed to persist trend selections", error);
  }
};

export const loadTrendSelections = (systemId) => {
  if (!systemId) return null;
  try {
    const raw = localStorage.getItem(trendSelectionsStorageKey(systemId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || parsed.v !== STORAGE_VERSION) return null;
    const charts = parsed.charts;
    if (!charts || typeof charts !== "object") return null;
    const restored = { chart1: {}, chart2: {}, chart3: {}, chart4: {} };
    CHARTS.forEach((chart) => {
      const devices = charts[chart];
      if (!devices || typeof devices !== "object") return;
      Object.keys(devices).forEach((hwId) => {
        const values = devices[hwId];
        if (!values || typeof values !== "object") return;
        restored[chart][hwId] = {};
        Object.keys(values).forEach((valueName) => {
          restored[chart][hwId][valueName] = {
            ...stripRuntimeFields(values[valueName]),
            loading: false,
          };
        });
      });
    });
    return isEmptySelection(restored) ? null : restored;
  } catch (error) {
    console.warn("Failed to read persisted trend selections", error);
    return null;
  }
};

export const clearTrendSelections = (systemId) => {
  if (!systemId) return;
  try {
    localStorage.removeItem(trendSelectionsStorageKey(systemId));
  } catch (error) {
    console.warn("Failed to clear persisted trend selections", error);
  }
};
